export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      repeatedNotices: [
        {
          noticeId: 6,
          noticeUuid: "notice006",
          createdAt: 1234567890123,
          deliveryType: "signage",
          deliveryTypeName: "サイネージ",
          noticeType: "opinionaire",
          noticeTypeName: "アンケート",
          deliveryToKbn: 0,
          repeatedNoticeStatus: 1,
          noticeContents: "地元の名産品について",
          noticeSenderName: "アイラ地域サポート",
        },
        {
          noticeId: 5,
          noticeUuid: "notice005",
          createdAt: 1234567890123,
          deliveryType: "normal",
          deliveryTypeName: "お知らせ",
          noticeType: "sound_broadcast",
          noticeTypeName: "音声定時放送",
          deliveryToKbn: 1,
          repeatedNoticeStatus: 2,
          noticeContents: "音声定時放送",
          noticeSenderName: "アイラ地域サポート",
        },
        {
          noticeId: 4,
          noticeUuid: "notice004",
          createdAt: 1234567890123,
          deliveryType: "normal",
          deliveryTypeName: "お知らせ",
          noticeType: "text",
          noticeTypeName: "テキストのみ",
          deliveryToKbn: 2,
          repeatedNoticeStatus: 2,
          noticeContents: "〇〇大会延期のお知らせ",
          noticeSenderName: "アイラ地域サポート",
        }
      ]
    }
  }
}